import palette from "@ubnt/ui-components/styles/designToken/palette";

export type TLightPalette = {
  [Property in keyof typeof light]: string;
};

export const light = {
  black: palette["desktop-color-black-light"],
  text1: palette["desktop-color-text-1-light"],
  text2: palette["desktop-color-text-2-light"],
  text3: palette["desktop-color-text-3-light"],
  text4: palette["desktop-color-text-4-light"],
  depth0: palette["desktop-color-depth-0-light"],
  depth1: palette["desktop-color-depth-1-light"],
  depth2: palette["desktop-color-depth-2-light"],
  depth3: palette["desktop-color-depth-3-light"],
  depth4: palette["desktop-color-depth-4-light"],
  ublue01: palette["desktop-color-ublue-01-light"],
  ublue02: palette["desktop-color-ublue-02-light"],
  ublue03: palette["desktop-color-ublue-03-light"],
  ublue04: palette["desktop-color-ublue-04-light"],
  ublue05: palette["desktop-color-ublue-05-light"],
  ublue06: palette["desktop-color-ublue-06-light"],
  ublue07: palette["desktop-color-ublue-07-light"],
  ublue08: palette["desktop-color-ublue-08-light"],
  ublue09: palette["desktop-color-ublue-09-light"],
  ublue10: palette["desktop-color-ublue-10-light"],
  neutral00: palette["desktop-color-neutral-00-light"],
  neutral01: palette["desktop-color-neutral-01-light"],
  neutral02: palette["desktop-color-neutral-02-light"],
  neutral03: palette["desktop-color-neutral-03-light"],
  neutral04: palette["desktop-color-neutral-04-light"],
  neutral05: palette["desktop-color-neutral-05-light"],
  neutral06: palette["desktop-color-neutral-06-light"],
  neutral07: palette["desktop-color-neutral-07-light"],
  neutral08: palette["desktop-color-neutral-08-light"],
  neutral09: palette["desktop-color-neutral-09-light"],
  neutral10: palette["desktop-color-neutral-10-light"],
  neutral11: palette["desktop-color-neutral-11-light"],
  neutral12: palette["desktop-color-neutral-12-light"],
  green01: palette["desktop-color-green-01-light"],
  green02: palette["desktop-color-green-02-light"],
  green03: palette["desktop-color-green-03-light"],
  green04: palette["desktop-color-green-04-light"],
  green05: palette["desktop-color-green-05-light"],
  green06: palette["desktop-color-green-06-light"],
  green07: palette["desktop-color-green-07-light"],
  green08: palette["desktop-color-green-08-light"],
  green09: palette["desktop-color-green-09-light"],
  green10: palette["desktop-color-green-10-light"],
  red01: palette["desktop-color-red-01-light"],
  red02: palette["desktop-color-red-02-light"],
  red03: palette["desktop-color-red-03-light"],
  red04: palette["desktop-color-red-04-light"],
  red05: palette["desktop-color-red-05-light"],
  red06: palette["desktop-color-red-06-light"],
  red07: palette["desktop-color-red-07-light"],
  red08: palette["desktop-color-red-08-light"],
  red09: palette["desktop-color-red-09-light"],
  red10: palette["desktop-color-red-10-light"],
  orange01: palette["desktop-color-orange-01-light"],
  orange02: palette["desktop-color-orange-02-light"],
  orange03: palette["desktop-color-orange-03-light"],
  orange04: palette["desktop-color-orange-04-light"],
  orange05: palette["desktop-color-orange-05-light"],
  orange06: palette["desktop-color-orange-06-light"],
  orange07: palette["desktop-color-orange-07-light"],
  orange08: palette["desktop-color-orange-08-light"],
  orange09: palette["desktop-color-orange-09-light"],
  orange10: palette["desktop-color-orange-10-light"],
  purple01: palette["desktop-color-purple-01-light"],
  purple02: palette["desktop-color-purple-02-light"],
  purple03: palette["desktop-color-purple-03-light"],
  purple04: palette["desktop-color-purple-04-light"],
  purple05: palette["desktop-color-purple-05-light"],
  purple06: palette["desktop-color-purple-06-light"],
  purple07: palette["desktop-color-purple-07-light"],
  purple08: palette["desktop-color-purple-08-light"],
  purple09: palette["desktop-color-purple-09-light"],
  purple10: palette["desktop-color-purple-10-light"],
  navy01: palette["desktop-color-navy-01-light"],
  navy02: palette["desktop-color-navy-02-light"],
  navy03: palette["desktop-color-navy-03-light"],
  navy04: palette["desktop-color-navy-04-light"],
  navy05: palette["desktop-color-navy-05-light"],
  navy06: palette["desktop-color-navy-06-light"],
  navy07: palette["desktop-color-navy-07-light"],
  navy08: palette["desktop-color-navy-08-light"],
  navy09: palette["desktop-color-navy-09-light"],
  navy10: palette["desktop-color-navy-10-light"],
  aqua01: palette["desktop-color-aqua-01-light"],
  aqua02: palette["desktop-color-aqua-02-light"],
  aqua03: palette["desktop-color-aqua-03-light"],
  aqua04: palette["desktop-color-aqua-04-light"],
  aqua05: palette["desktop-color-aqua-05-light"],
  aqua06: palette["desktop-color-aqua-06-light"],
  aqua07: palette["desktop-color-aqua-07-light"],
  aqua08: palette["desktop-color-aqua-08-light"],
  aqua09: palette["desktop-color-aqua-09-light"],
  aqua10: palette["desktop-color-aqua-10-light"],
  lime01: palette["desktop-color-lime-01-light"],
  lime02: palette["desktop-color-lime-02-light"],
  lime03: palette["desktop-color-lime-03-light"],
  lime04: palette["desktop-color-lime-04-light"],
  lime05: palette["desktop-color-lime-05-light"],
  lime06: palette["desktop-color-lime-06-light"],
  lime07: palette["desktop-color-lime-07-light"],
  lime08: palette["desktop-color-lime-08-light"],
  lime09: palette["desktop-color-lime-09-light"],
  lime10: palette["desktop-color-lime-10-light"],
  yellow01: palette["desktop-color-yellow-01-light"],
  yellow02: palette["desktop-color-yellow-02-light"],
  yellow03: palette["desktop-color-yellow-03-light"],
  yellow04: palette["desktop-color-yellow-04-light"],
  yellow05: palette["desktop-color-yellow-05-light"],
  yellow06: palette["desktop-color-yellow-06-light"],
  yellow07: palette["desktop-color-yellow-07-light"],
  yellow08: palette["desktop-color-yellow-08-light"],
  yellow09: palette["desktop-color-yellow-09-light"],
  yellow10: palette["desktop-color-yellow-10-light"],
  aquagradient: palette["desktop-color-aqua-gradient-light"],
  navygradient: palette["desktop-color-navy-gradient-light"],
  downloadgradient: palette["desktop-color-download-gradient-light"],
  uploadgradient: palette["desktop-color-upload-gradient-light"],
};
